import { useRef, useLayoutEffect, useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Typography, Tooltip, Box } from '@mui/material'

import useStyles from './styles'

const SwitchLabel = ({
  label,
  subLabel,
  additionalText,
  disabled,
  multiline = true,
  amount,
  currency = '€',
  checked,
}) => {
  const classes = useStyles()
  let subLabelRef = useRef(null)
  const [showToolbar, setShowToolbar] = useState(false)

  useLayoutEffect(() => {
    if (multiline) {
      return
    }

    setShowToolbar(() => {
      return (
        subLabelRef?.current?.scrollWidth > subLabelRef?.current?.clientWidth
      )
    })
  }, [subLabelRef, multiline])

  const SwitchLabelWrapperWithAmount = ({ children }) => (
    <Box className={classes.switchLabelWrapperWithAmount}>{children}</Box>
  )
  SwitchLabelWrapperWithAmount.propTypes = {
    children: PropTypes.node,
  }

  const SwitchLabelWrapper = amount ? SwitchLabelWrapperWithAmount : Fragment

  return (
    <SwitchLabelWrapper>
      <Box className={clsx({ [classes.containerWithAmount]: amount })}>
        {label ? (
          <Typography
            className={clsx(classes.label, {
              [classes.disabled]: disabled,
              [classes.checked]: checked,
              'has-gutterBottomSmall': amount,
            })}
          >
            {label}
          </Typography>
        ) : null}
        {subLabel ? (
          <Tooltip
            title={<Typography variant="body2">{subLabel}</Typography>}
            arrow
            placement="top"
            ref={subLabelRef}
            disableFocusListener={multiline || !showToolbar}
            disableHoverListener={multiline || !showToolbar}
            disableTouchListener={multiline || !showToolbar}
          >
            <Box>
              <Typography
                className={clsx(classes.subLabel, {
                  [classes.disabled]: disabled,
                  [classes.checked]: checked,
                })}
              >
                {subLabel}
              </Typography>
              {additionalText && (
                <Typography variant="body2">{additionalText}</Typography>
              )}
            </Box>
          </Tooltip>
        ) : null}
      </Box>
      {amount ? (
        <Typography variant="inputText" className="radioAmount">
          {amount.toString().replace('.', ',')}
          {currency}
        </Typography>
      ) : null}
    </SwitchLabelWrapper>
  )
}

SwitchLabel.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  additionalText: PropTypes.string,
  disabled: PropTypes.bool,
  multiline: PropTypes.bool,
  amount: PropTypes.number,
  currency: PropTypes.string,
}

export default SwitchLabel
